import script from "./AsinStack.vue?vue&type=script&setup=true&lang=js"
export * from "./AsinStack.vue?vue&type=script&setup=true&lang=js"

import "./AsinStack.vue?vue&type=style&index=0&id=efd55af4&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd55af4"]])

export default __exports__